export const data = {
  dynamicbidata: [
    {
      card_name: "จำนวนลูกค้าทั้งหมด",
      keyid: "summary-customer",
      tooltip: "Active คือ เข้าใช้งานภายใน 30 วัน <br/> Inactive คือ ไม่ได้เข้าใช้งานเกิน 30 วัน", 
      data: [
        {
          title: "Active",
          value: 456789,
          unit: "คน",
          color: "#ffcf01"
        },
        {
          title: "Inactive",
          value: 123456,
          unit: "คน",
          color: "#000000"
        }
      ]
    },
    {
      card_name: "card_namecard_namecard_namecard_name",
      keyid: 'summary-point',
      tooltip: "test", 
      data: [
        {
          title: "จำนวนคะแนนทั้งหมด",
          value: 123456,
          unit: "คะแนน"
        },
        {
          title: "คะแนนที่ใช้ไป",
          value: 123456,
          unit: "คะแนน"
        },
        {
          title: "คะแนนคงเหลือ",
          value: 123456,
          unit: "คะแนน"
        }
      ]
    },
    {
      card_name: "card_namecard_namecard_namecard_name",
      keyid: 'summary-point-cus',
      tooltip: "test", 
      data: [
        {
          title: "จำนวนลูกค้าที่สะสมคะแนน",
          value: 123456,
          unit: "คน"
        },
        {
          title: "จำนวนครั้งที่สะสมคะแนน",
          value: 123456,
          unit: "ครั้ง"
        }
      ]
    },
    {
      card_name: "5 อันดับ ลูกค้าที่มีคะแนนสะสมสูงสุด",
      keyid: 'customers-highest-point',
      tooltip: "test", 
      fields:[
        {
          seq: 1,
          key: "seq",
          label: "อันดับ",
        },
        {
          seq: 2,
          key: "img",
          label: "",
        },
        {
          seq: 3,
          key: "namelastname_TH",
          label: "ชื่อ-นามสกุล",
        },
        {
          seq: 4,
          key: "point",
          label: "คะแนน",
        }
      ],
      data: [
        {
          seq: 1,
          img: null,
          namelastname_TH: "นาย111 นามสกุล111",
          namelastnamex: "นาย000 นามสกุล000",
          point: "100000"
        },
        {
          seq: 2,
          img: null,
          namelastname: "นาย222 นามสกุล222",
          point: "10000"
        },
        {
          seq: 3,
          img: null,
          namelastname: "นาย333 นามสกุล333",
          point: "1000"
        },
        {
          seq: 4,
          img: null,
          namelastname: "นาย444 นามสกุล444",
          point: "100"
        },
        {
          seq: 5,
          img: null,
          namelastname: "นาย555 นามสกุล555",
          point: "10"
        },
      ]
    },
    {
      card_name: "เพศของลูกค้า",
      keyid: 'summary-count-gender',
      tooltip: "test", 
      data: [
        {
          type: "woman",
          title: "หญิง",
          percent: "50%",
          value: "1000000",
          unit: "คน",
        },
        {
          type: "man",
          title: "ชาย",
          percent: "20%",
          value: "1000000",
          unit: "คน",
        },
        {
          type: "noGender",
          title: "ไม่ระบุ",
          percent: "30%",
          value: "1000000",
          unit: "คน",
        }
      ]
    },
    {
      card_name: "จำนวนครั้งที่แลกของรางวัล",
      keyid: 'summary-count-issue',
      tooltip: null, 
      data: [
        {
          title: "Coupon Code",
          value: 4000000,
          unit: "ครั้ง",
          color: "#ffcf01"
        },
        {
          title: "Reward/Privilege",
          value: 1000000,
          unit: "ครั้ง",
          color: "#000000"
        }
      ]
    },
    {
      card_name: "5 อันดับ ของรางวัลที่มีการแลกสูงสุด",
      keyid: 'reward-highest-redeem',
      tooltip: "test", 
      fields:[
        {
          seq: 1,
          key: "seq",
          label: "อันดับ",
        },
        {
          seq: 2,
          key: "img",
          label: "รูปภาพ",
        },
        {
          seq: 3,
          key: "rewardName",
          label: "ชื่อของรางวัล",
        },
        {
          seq: 4,
          key: "rewardType",
          label: "ประเภทของรางวัล",
        },
        {
          seq: 5,
          key: "category",
          label: "หมวดหมู่",
        },
        {
          seq: 6,
          key: "countCrm",
          label: "จำนวนลูกค้า",
        },
        {
          seq: 7,
          key: "countReward",
          label: "ยอดรวมการแลกของรางวัล",
        },
      ],
      data: [
        {
          seq: 1,
          img: null,
          rewardName: "ชื่อของรางวัล 1",
          rewardType: "Reward/Privilege",
          category: "อาหาร",
          countCrm: "10000",
          countReward: "100000",
        },
        {
          seq: 2,
          img: null,
          rewardName: "ชื่อของรางวัล 2",
          rewardType: "Reward/Privilege",
          category: "อาหาร",
          countCrm: "10000",
          countReward: "100000",
        },
        {
          seq: 3,
          img: null,
          rewardName: "ชื่อของรางวัล 3",
          rewardType: "Reward/Privilege",
          category: "อาหาร",
          countCrm: "10000",
          countReward: "100000",
        },
        {
          seq: 4,
          img: null,
          rewardName: "ชื่อของรางวัล 4",
          rewardType: "Reward/Privilege",
          category: "อาหาร",
          countCrm: "10000",
          countReward: "100000",
        },
        {
          seq: 5,
          img: null,
          rewardName: "ชื่อของรางวัล 5",
          rewardType: "Reward/Privilege",
          category: "อาหาร",
          countCrm: "10000",
          countReward: "100000",
        },
      ]
    },
    {
      card_name: "5 อันดับ จังหวัดที่มีจำนวนลูกค้ามากที่สุด",
      keyid: 'province-highest-customer',
      tooltip: "test", 
      fields:[
        {
          seq: 1,
          key: "seq",
          label: "อันดับ",
        },
        {
          seq: 2,
          key: "provinceName",
          label: "ชื่อจังหวัด",
        },
        {
          seq: 3,
          key: "countCrm",
          label: "จำนวนลูกค้า",
        }
      ],
      data: [
        {
          seq: 1,
          provinceName: "กรุงเทพมหานคร",
          countCrm: "9999"
        },
        {
          seq: 2,
          provinceName: "เชียงใหม่",
          countCrm: "8888"
        },
        {
          seq: 3,
          provinceName: "เชียงราย",
          countCrm: "7777"
        },
        {
          seq: 4,
          provinceName: "เลย",
          countCrm: "6666"
        },
        {
          seq: 5,
          provinceName: "กาญจนบุรี",
          countCrm: "55555"
        },
      ]
    },
  ],
};
  